export default __webpack_public_path__ + "static/media/banner_ocsb.2753dbb8.png";